import API from '../../apiConfig';

export const addInventory = async (data) => {
  const response = await API.post('supplier/deal', data);
  return response;
};

export const deleteInventoryAPI = async (data) => {
  const response = await API.remove('supplier/deal', data);
  return response;
};

export const fetchInventory = async (data) => {
  const login_data = localStorage.getItem('login_data');
  const supplierId = JSON.parse(login_data)?.user_id;
  const response = await API.get(`supplier/deal`, {
    params: data,
  });
  return response;
};

export const searchProducts = async (data) => {
  const response = await API.get('products/productByModelName', { params: data });
  return response;
};

export const bulkInventory = async (data) => {
  const response = await API.post('supplier/bulkInventory/vendor', data);
  return response;
};
export const fetchInventoryCount = async (supplierId) => {
  // const login_data = localStorage.getItem('login_data');
  // const supplierId = JSON.parse(login_data).user_id;
  const response = await API.get(`supplier/inventory/details?supplierId=${supplierId}`);
  return response;
};
export const catalogueRequest = async (data) => {
  const response = await API.post('supplier/catalogue/request', data);
  return response;
};
export const fetchInventoryRequest = async (data) => {
  const response = await API.get('supplier/catalogue/request', { params: data });
  return response;
};
export const fetchCategoryList = async (supplierId) => {
  const response = await API.get(`/supplier/products?supplierId=${supplierId}`);
  return response;
};
